var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.searchingConfig } }, [
    _c(
      "div",
      [
        _c(
          "form",
          {
            attrs: { "data-vv-scope": "flow-part-1" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", [_vm._v("Datos para el flujo")])
              ])
            ]),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      label: "Nombre para el flujo (*)",
                      maxlength: "120",
                      name: "name",
                      danger: _vm.errors.has("flow-part-1.name"),
                      "danger-text": _vm.errors.first("flow-part-1.name")
                    },
                    model: {
                      value: _vm.step.name,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "name", $$v)
                      },
                      expression: "step.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      label: "Descripción para el flujo (*)",
                      name: "description",
                      danger: _vm.errors.has("flow-part-1.description"),
                      "danger-text": _vm.errors.first(
                        "flow-part-1.description"
                      ),
                      maxlength: "550"
                    },
                    model: {
                      value: _vm.step.description,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "description", $$v)
                      },
                      expression: "step.description"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row mb-3" }, [
              !_vm.isConvention
                ? _c("div", { staticClass: "col-md-6 mt-3" }, [
                    !_vm.step.oldFlow
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            attrs: { "data-cy": "stamp-approvals" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-8 d-flex align-items-end"
                              },
                              [
                                _c("label", [_vm._v("Estampar aprobaciones")]),
                                _c("InfoApprovalStamp")
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-md-2" },
                              [
                                _c(
                                  "vs-radio",
                                  {
                                    attrs: {
                                      "vs-name": "pdfStamp",
                                      "vs-value": true,
                                      "data-cy": "pdfStampYes"
                                    },
                                    model: {
                                      value: _vm.step.pdfStamp,
                                      callback: function($$v) {
                                        _vm.$set(_vm.step, "pdfStamp", $$v)
                                      },
                                      expression: "step.pdfStamp"
                                    }
                                  },
                                  [_vm._v(" Si ")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-md-2" },
                              [
                                _c(
                                  "vs-radio",
                                  {
                                    attrs: {
                                      "vs-name": "pdfStamp",
                                      "vs-value": false,
                                      "data-cy": "pdfStampNo"
                                    },
                                    model: {
                                      value: _vm.step.pdfStamp,
                                      callback: function($$v) {
                                        _vm.$set(_vm.step, "pdfStamp", $$v)
                                      },
                                      expression: "step.pdfStamp"
                                    }
                                  },
                                  [_vm._v(" No ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("div", { staticClass: "col-md-6 mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    attrs: { "data-cy": "private-stream" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-8 d-flex align-items-end" },
                      [
                        _c("label", [_vm._v("Flujo privado")]),
                        _c("InfoPrivateFlow")
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(
                          "vs-radio",
                          {
                            attrs: {
                              "vs-name": "private",
                              "vs-value": true,
                              "data-cy": "privateYes"
                            },
                            model: {
                              value: _vm.step.private,
                              callback: function($$v) {
                                _vm.$set(_vm.step, "private", $$v)
                              },
                              expression: "step.private"
                            }
                          },
                          [_vm._v(" Si ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(
                          "vs-radio",
                          {
                            attrs: {
                              "vs-name": "private",
                              "vs-value": false,
                              "data-cy": "privateNo"
                            },
                            model: {
                              value: _vm.step.private,
                              callback: function($$v) {
                                _vm.$set(_vm.step, "private", $$v)
                              },
                              expression: "step.private"
                            }
                          },
                          [_vm._v(" No ")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              !_vm.step.oldFlow
                ? _c(
                    "div",
                    { staticClass: "col-md-6 mt-3" },
                    [
                      _c("BooleanParameter", {
                        attrs: {
                          "is-approval-sign": true,
                          "data-cy": "define-signature-location",
                          disabled: _vm.disableSignaturePosition,
                          "param-id": "aprobaciones.firmas.ubicacion"
                        },
                        on: { input: _vm.onSetSignaturePositionChange },
                        model: {
                          value: _vm.step.setSignaturePosition,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "setSignaturePosition", $$v)
                          },
                          expression: "step.setSignaturePosition"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-md-6 mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    attrs: {
                      "data-cy":
                        "Do-you-want-to-base-yourself-on-a-current-flow?"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-8 d-flex align-items-end" },
                      [
                        _c("label", [
                          _vm._v("¿Quieres basarte en un flujo actual?")
                        ]),
                        _c("InfoOldApproval")
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(
                          "vs-radio",
                          {
                            attrs: {
                              "vs-name": "oldFlow",
                              "vs-value": true,
                              "data-cy": "oldFlowYes"
                            },
                            model: {
                              value: _vm.step.oldFlow,
                              callback: function($$v) {
                                _vm.$set(_vm.step, "oldFlow", $$v)
                              },
                              expression: "step.oldFlow"
                            }
                          },
                          [_vm._v(" Si ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(
                          "vs-radio",
                          {
                            attrs: {
                              "vs-name": "oldFlow",
                              "vs-value": false,
                              "data-cy": "oldFlowNo"
                            },
                            model: {
                              value: _vm.step.oldFlow,
                              callback: function($$v) {
                                _vm.$set(_vm.step, "oldFlow", $$v)
                              },
                              expression: "step.oldFlow"
                            }
                          },
                          [_vm._v(" No ")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm.step.oldFlow
                ? _c("div", { staticClass: "col-md-6 mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        attrs: { "data-cy": "plantilla-tipo" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12 d-flex align-items-end" },
                          [
                            _c("label", [
                              _vm._v("¿Que plantillas quieres ver?")
                            ]),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn-icon rounded-circle mt-1",
                                    attrs: {
                                      size: "sm",
                                      id: "popover-attended",
                                      variant: "flat-primary"
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "InfoIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      target: "popover-attended",
                                      triggers: "focus",
                                      placement: "top"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function() {
                                            return [
                                              _c("span", [
                                                _vm._v("Tipo de plantilla!")
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2424952843
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _c("strong", [_vm._v("Atendidas:")]),
                                      _vm._v(
                                        " Flujos con interacción humana en donde cada participante debe realizar sus acciones "
                                      )
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _c("strong", [_vm._v(" Desatendidas: ")]),
                                      _vm._v(
                                        " Flujos sin interacción humana que se procesan automáticamente "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        attrs: { "data-cy": "plantilla-tipo-opciones" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c(
                              "vs-radio",
                              {
                                attrs: {
                                  "vs-name": "attendedOnly",
                                  "vs-value": 0,
                                  "data-cy": "attendedOnly-0"
                                },
                                model: {
                                  value: _vm.attendedOnly,
                                  callback: function($$v) {
                                    _vm.attendedOnly = $$v
                                  },
                                  expression: "attendedOnly"
                                }
                              },
                              [_vm._v(" Atendidas ")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c(
                              "vs-radio",
                              {
                                attrs: {
                                  "vs-name": "attendedOnly",
                                  disabled: _vm.disableDesattendedOnly,
                                  "vs-value": 1,
                                  "data-cy": "attendedOnly-1"
                                },
                                model: {
                                  value: _vm.attendedOnly,
                                  callback: function($$v) {
                                    _vm.attendedOnly = $$v
                                  },
                                  expression: "attendedOnly"
                                }
                              },
                              [_vm._v(" Desatendidas ")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm.step.oldFlow
                ? _c(
                    "div",
                    { staticClass: "col-md-6 mt-3" },
                    [
                      _c("label", { attrs: { for: "flow-select" } }, [
                        _vm._v(" Selecciona el flujo ")
                      ]),
                      _c(
                        "v-select",
                        {
                          attrs: {
                            options: _vm.filteredApprovalsTemplates,
                            name: "flow-select",
                            id: "flow-select",
                            label: "nombre",
                            "data-cy": "select-template",
                            placeholder: "Selecciona el flujo",
                            reduce: function(option) {
                              return option.id
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function(ref) {
                                  var id = ref.id
                                  var nombre = ref.nombre
                                  return [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-cy-value": id,
                                          "data-cy-label": nombre
                                        }
                                      },
                                      [_vm._v(" " + _vm._s(nombre) + " ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            936322944
                          ),
                          model: {
                            value: _vm.step.flowId,
                            callback: function($$v) {
                              _vm.$set(_vm.step, "flowId", $$v)
                            },
                            expression: "step.flowId"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(" no hay flujos ")
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
                [
                  _c("list-all-document-types", {
                    ref: "documentTypes",
                    staticClass: "w-100",
                    attrs: {
                      "data-vv-as": "tipo documento",
                      usage: "aprobaciones",
                      autocomplete: "",
                      label: "Tipo Documento",
                      name: "documentType"
                    },
                    on: { "input-option": _vm.onDocumentTypeChange },
                    model: {
                      value: _vm.step.documentType,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "documentType", $$v)
                      },
                      expression: "step.documentType"
                    }
                  })
                ],
                1
              ),
              _vm.loadingActionsOffice
                ? _c(
                    "div",
                    { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
                    [
                      _c("b-spinner", {
                        attrs: { small: "", variant: "primary" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.loadingActionsOffice && _vm.documentHasOficeActions
                ? _c(
                    "div",
                    { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Oficina de partes que numera (*)" }
                        },
                        [
                          _c(
                            "v-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-vv-as": "oficina que numera",
                                name: "numerationOffice",
                                danger: _vm.errors.has(
                                  "flow-part-1.numerationOffice"
                                ),
                                "danger-text": _vm.errors.first(
                                  "flow-part-1.numerationOffice"
                                ),
                                disabled: _vm.step.office.list.length === 1,
                                options: _vm.step.office.list,
                                placeholder: "Selecciona una oficina"
                              },
                              on: { input: _vm.selectActionsOffice },
                              model: {
                                value: _vm.step.office.selected,
                                callback: function($$v) {
                                  _vm.$set(_vm.step.office, "selected", $$v)
                                },
                                expression: "step.office.selected"
                              }
                            },
                            [
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  " no hay tipos de documentos para el criterio de búsqueda "
                                )
                              ])
                            ],
                            2
                          ),
                          _vm.errors.has("flow-part-1.numerationOffice")
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "flow-part-1.numerationOffice"
                                      ) || ""
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _vm._l(_vm.step.actions, function(action, $index) {
                            return _c(
                              "span",
                              {
                                key: $index + "action",
                                staticClass: "badge badge-primary ml-3"
                              },
                              [_vm._v(" " + _vm._s(action.action) + " ")]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isConvention && !_vm.isAguasAndinas
                ? _c(
                    "div",
                    { staticClass: "col-md-6 mt-3" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required:
                                _vm.step.executionType === "P" &&
                                !_vm.isConvention
                            },
                            expression:
                              "{ required: step.executionType === 'P' && !isConvention }"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          label: "Monto",
                          name: "amount",
                          danger: _vm.errors.has("flow-part-1.amount"),
                          "danger-text": _vm.errors.first("flow-part-1.amount")
                        },
                        model: {
                          value: _vm.step.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "amount", $$v)
                          },
                          expression: "step.amount"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && _vm.isResponse
                ? _c(
                    "div",
                    { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
                    [
                      _c("list-institution-types", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        ref: "institutionType",
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Tipo Institución (*)",
                          name: "institutionType",
                          danger: _vm.errors.has("flow-part-1.institutionType"),
                          "danger-text": _vm.errors.first(
                            "flow-part-1.institutionType"
                          )
                        },
                        model: {
                          value: _vm.step.institutionType,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "institutionType", $$v)
                          },
                          expression: "step.institutionType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm.isAguasAndinas && _vm.isResponse
              ? _c("div", { staticClass: "row mt-3 mb-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("label", { attrs: { for: "matter" } }, [
                        _vm._v("Materia (*)")
                      ]),
                      _c("vs-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.isAguasAndinas && _vm.isResponse,
                              min: 3
                            },
                            expression:
                              "{\n              required: isAguasAndinas && isResponse,\n              min: 3\n            }"
                          }
                        ],
                        staticClass: "mb-0",
                        attrs: {
                          type: "text",
                          id: "matter",
                          label:
                            "Materia (Mínimo 3 caracteres, máximo 5000 caracteres)",
                          "data-cy": "matter",
                          name: "matter",
                          width: "100%",
                          height: "100px",
                          maxlength: "5000"
                        },
                        model: {
                          value: _vm.step.matter,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "matter", $$v)
                          },
                          expression: "step.matter"
                        }
                      }),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 text-left" }, [
                          _vm.errors.first("flow-part-1.matter")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to",
                                  staticStyle: { height: "32px" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "span-text-validation" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "flow-part-1.matter"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "col-md-6 text-right" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Contador de caracteres",
                                  expression: "'Contador de caracteres'"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.step.matter.length) + "/5000")]
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("label", [_vm._v("Fecha Documento")]),
                      _c(
                        "b-form-datepicker",
                        _vm._b(
                          {
                            attrs: {
                              "today-button": "",
                              "reset-button": "",
                              "close-button": "",
                              max: _vm.maxDate,
                              locale: _vm.locale,
                              "show-decade-nav": false,
                              "hide-header": false,
                              name: "issueDate",
                              "data-vv-as": "fecha documento",
                              "data-cy": "issue-date"
                            },
                            model: {
                              value: _vm.step.issueDate,
                              callback: function($$v) {
                                _vm.$set(_vm.step, "issueDate", $$v)
                              },
                              expression: "step.issueDate"
                            }
                          },
                          "b-form-datepicker",
                          _vm.configBFormDate.labels[_vm.locale] || {},
                          false
                        )
                      ),
                      _vm.errors.has("flow-part-1.issueDate")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "flow-part-1.issueDate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-3 col-xs-12 col-sm-12" },
                [
                  _c("UploadFile", {
                    attrs: {
                      permission: "*",
                      accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                      text: "Cargar Documento Principal",
                      "data-cy": "load-principal-document",
                      "upload-to": "ed",
                      "button-class": {
                        "btn-block": true,
                        "mb-5": _vm.errors.has("flow-part-1.mainFileName")
                      },
                      "container-class": "w-100"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addFile()
                      }
                    },
                    model: {
                      value: _vm.step.mainFile,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "mainFile", $$v)
                      },
                      expression: "step.mainFile"
                    }
                  })
                ],
                1
              ),
              _vm.step.mainFile && Object.keys(_vm.step.mainFile).length
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-row align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "45px",
                            color: "primary"
                          }
                        }),
                        _c("b", { staticClass: "text-truncate w-100" }, [
                          _vm._v(_vm._s(_vm.step.mainFile.name))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "col-md-12 text-primary" }, [
                _vm._v(
                  " Si va a firmar documento, favor considerar el documento principal PDF o DOCX (este último requiere paso revisor previo). "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "row mb-3 mt-3" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-3 d-flex align-items-end" },
                  [
                    _c("UploadFile", {
                      attrs: {
                        permission: "*",
                        text: "Cargar Archivos Adjuntos",
                        accept: "application/pdf",
                        "data-cy": "load-attachments-document",
                        "upload-to": "ed",
                        "button-class": "btn-block",
                        "container-class": "w-100"
                      },
                      on: {
                        input: function($event) {
                          return _vm.addAdditionalFile()
                        }
                      },
                      model: {
                        value: _vm.additionalFile,
                        callback: function($$v) {
                          _vm.additionalFile = $$v
                        },
                        expression: "additionalFile"
                      }
                    })
                  ],
                  1
                ),
                _vm._l(_vm.step.attachments, function(file) {
                  return _c("div", { key: file.id, staticClass: "col-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "45px",
                            color: "primary"
                          }
                        }),
                        _c(
                          "b",
                          { staticClass: "text-truncate w-100 text-center" },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _c("vs-button", {
                          attrs: {
                            color: "danger",
                            type: "flat",
                            icon: "clear"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeAdditionalFile(file.id)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            )
          ]
        ),
        _vm.isResponse && _vm.isAguasAndinas
          ? _c("form", { attrs: { "data-vv-scope": "flow-part-1-2" } }, [
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
              ]),
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h4", [_vm._v("Documentos Relacionados")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-md-12 mb-3" },
                  [
                    _c("add-related-document", {
                      on: { "add-related-document": _vm.addRelatedDocument }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("table-related-documents", {
                      attrs: {
                        "related-documents": _vm.step.relatedDocuments,
                        multiple: ""
                      },
                      model: {
                        value: _vm.step.relatedDocumentsSelected,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                        },
                        expression: "step.relatedDocumentsSelected"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
              ])
            ])
          : _vm._e(),
        _c(
          "form",
          { attrs: { "data-vv-scope": "flow-part-2" } },
          [
            _vm.step.executionType === "P"
              ? _c("div", { staticClass: "row mb-3 mt-4" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h4", [_vm._v("Detalle del flujo")])
                  ])
                ])
              : _vm._e(),
            _vm.searchingFlow
              ? _c("small", { staticClass: "text-primary" }, [
                  _vm._v(
                    " Estamos buscando la información sobre el flujo que seleccionaste "
                  )
                ])
              : _vm._e(),
            _vm.step.oldFlow && _vm.oldFlow.pasos
              ? _c("StepsOldFlow", { attrs: { steps: _vm.oldFlow.pasos } })
              : _vm._e(),
            !_vm.step.oldFlow
              ? _c("div", { staticClass: "row mb-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-3 mt-2" },
                    [
                      _c(
                        "vs-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "Tipo de paso (*)",
                            name: "stepType",
                            danger: _vm.errors.has("flow-part-2.stepType"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.stepType"
                            )
                          },
                          on: { change: _vm.searchOffice },
                          model: {
                            value: _vm.stepType,
                            callback: function($$v) {
                              _vm.stepType = $$v
                            },
                            expression: "stepType"
                          }
                        },
                        [
                          _vm.loadingStepTypes
                            ? _c("vs-select-item", {
                                attrs: {
                                  value: null,
                                  text: "Cargando opciones...",
                                  disabled: ""
                                }
                              })
                            : _vm._e(),
                          _vm._l(_vm.tiposPasoIniciarFlujo, function(tipo) {
                            return _c("vs-select-item", {
                              key: tipo.valor,
                              attrs: {
                                value: tipo.valor,
                                text: tipo.descripcion
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm.stepType === this.stepTypes.OFFICE
                    ? _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("list-offices", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.stepType === this.stepTypes.OFFICE
                                },
                                expression:
                                  "{ required: stepType === this.stepTypes.OFFICE }"
                              }
                            ],
                            ref: "groupStep",
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "Oficina del responsable (*)",
                              name: "groupStep",
                              typeList: _vm.stepType,
                              officeType: _vm.wizardData.fileCategory,
                              danger: _vm.errors.has("flow-part-2.groupStep"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.groupStep"
                              )
                            },
                            model: {
                              value: _vm.groupStep,
                              callback: function($$v) {
                                _vm.groupStep = $$v
                              },
                              expression: "groupStep"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.USER
                    ? _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("list-user", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: _vm.stepType === _vm.stepTypes.USER
                                },
                                expression:
                                  "{ required: stepType === stepTypes.USER }"
                              }
                            ],
                            ref: "userStep",
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "Usuario (*)",
                              name: "userStep",
                              withFilters: "",
                              isApprovals: "",
                              danger: _vm.errors.has("flow-part-2.userStep"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.userStep"
                              )
                            },
                            model: {
                              value: _vm.userStep,
                              callback: function($$v) {
                                _vm.userStep = $$v
                              },
                              expression: "userStep"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.EXTERNAL ||
                  _vm.stepType === _vm.stepTypes.COMPLETION
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  validateRut: true,
                                  required:
                                    _vm.stepType === _vm.stepTypes.EXTERNAL ||
                                    _vm.stepType === _vm.stepTypes.COMPLETION
                                },
                                expression:
                                  "{ validateRut: true, required: stepType === stepTypes.EXTERNAL || stepType === stepTypes.COMPLETION }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Rut empresa o institución (*)",
                              name: "companyIut",
                              "data-vv-as": "rut empresa",
                              "data-vv-validate-on": "blur",
                              "data-cy": "company-iut",
                              placeholder: "12345678-9",
                              autocomplete: "off",
                              danger: _vm.errors.has("flow-part-2.companyIut"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.companyIut"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.formatRut(
                                  _vm.step.extern,
                                  "iut",
                                  "companyIut"
                                )
                              }
                            },
                            model: {
                              value: _vm.step.extern.iut,
                              callback: function($$v) {
                                _vm.$set(_vm.step.extern, "iut", $$v)
                              },
                              expression: "step.extern.iut"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.PERSON
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  validateRut: true,
                                  required:
                                    _vm.stepType === _vm.stepTypes.PERSON
                                },
                                expression:
                                  "{ validateRut: true, required: stepType === stepTypes.PERSON }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Rut",
                              name: "personIut",
                              "data-cy": "person-iut",
                              placeholder: "12345678-9",
                              autocomplete: "off",
                              danger: _vm.errors.has("flow-part-2.personIut"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.personIut"
                              )
                            },
                            model: {
                              value: _vm.step.person.iut,
                              callback: function($$v) {
                                _vm.$set(_vm.step.person, "iut", $$v)
                              },
                              expression: "step.person.iut"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.PERSON
                    ? _c(
                        "div",
                        { staticClass: "col-5 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.stepType === _vm.stepTypes.PERSON
                                },
                                expression:
                                  "{ required: stepType === stepTypes.PERSON }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              "data-vv-as": "nombre",
                              "data-cy": "person-name",
                              label: "Nombre",
                              name: "personName",
                              autocomplete: "off",
                              danger: _vm.errors.has("flow-part-2.personName"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.personName"
                              )
                            },
                            model: {
                              value: _vm.step.person.name,
                              callback: function($$v) {
                                _vm.$set(_vm.step.person, "name", $$v)
                              },
                              expression: "step.person.name"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.PERSON
                    ? _c(
                        "div",
                        { staticClass: "col-12 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Correo",
                              type: "email",
                              "data-vv-as": "correo",
                              "data-cy": "person-email",
                              name: "personEmail",
                              danger: _vm.errors.has("flow-part-2.personEmail"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.personEmail"
                              )
                            },
                            model: {
                              value: _vm.step.person.email,
                              callback: function($$v) {
                                _vm.$set(_vm.step.person, "email", $$v)
                              },
                              expression: "step.person.email"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isExternLikeStep
                    ? _c(
                        "div",
                        { staticClass: "col-1 text-center mt-3" },
                        [
                          _c(
                            "b-overlay",
                            { attrs: { show: _vm.loadingCompany } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Buscar empresa",
                                      expression: "'Buscar empresa'"
                                    }
                                  ],
                                  staticClass:
                                    "btn-icon rounded-circle p-3 mt-5",
                                  attrs: {
                                    "data-cy": "search-company",
                                    variant: "primary",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.searchCompanyIut()
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "SearchIcon" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.externCompany.iut && _vm.isExternLikeStep
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: _vm.isExternLikeStep },
                                expression: "{ required: isExternLikeStep }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Razón empresa (*)",
                              name: "razonSocial",
                              "data-cy": "business-name",
                              danger: _vm.errors.has("flow-part-2.razonSocial"),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.razonSocial"
                              )
                            },
                            model: {
                              value: _vm.externCompany.razonSocial,
                              callback: function($$v) {
                                _vm.$set(_vm.externCompany, "razonSocial", $$v)
                              },
                              expression: "externCompany.razonSocial"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.externCompany.iut &&
                  !_vm.newCompany &&
                    _vm.externCompany.users &&
                    _vm.externCompany.users.length &&
                  _vm.isExternLikeStep
                    ? _c("div", { staticClass: "col-4 mt-3" }, [
                        _c(
                          "div",
                          [
                            _vm._v(" Posibles firmantes "),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Ver usuarios de la empresa",
                                    expression: "'Ver usuarios de la empresa'"
                                  },
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal",
                                    value: "users-extern-company",
                                    expression: "'users-extern-company'"
                                  }
                                ],
                                staticClass: "btn-icon rounded-circle p-3 mt-5",
                                attrs: { variant: "secondary", size: "sm" }
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "UsersIcon" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.externCompany.iut && _vm.isExternLikeStep
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  validateRut: true,
                                  required: _vm.isExternLikeStep
                                },
                                expression:
                                  "{ validateRut: true, required: isExternLikeStep }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Rut del firmante (*)",
                              name: "responsibleIut",
                              "data-vv-as": "rut del firmante",
                              "data-vv-validate-on": "blur",
                              "data-cy": "responsible-iut",
                              placeholder: "12345678-9",
                              danger: _vm.errors.has(
                                "flow-part-2.responsibleIut"
                              ),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.responsibleIut"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.formatRut(
                                  _vm.step.extern,
                                  "responsibleIut",
                                  "responsibleIut"
                                )
                              }
                            },
                            model: {
                              value: _vm.step.extern.responsibleIut,
                              callback: function($$v) {
                                _vm.$set(_vm.step.extern, "responsibleIut", $$v)
                              },
                              expression: "step.extern.responsibleIut"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.externCompany.iut && _vm.isExternLikeStep
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: _vm.isExternLikeStep },
                                expression: "{ required: isExternLikeStep }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Nombre del firmante (*)",
                              name: "responsibleName",
                              "data-vv-as": "nombre del firmante",
                              "data-vv-validate-on": "blur",
                              "data-cy": "responsible-name",
                              danger: _vm.errors.has(
                                "flow-part-2.responsibleName"
                              ),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.responsibleName"
                              )
                            },
                            model: {
                              value: _vm.step.extern.responsibleName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.step.extern,
                                  "responsibleName",
                                  $$v
                                )
                              },
                              expression: "step.extern.responsibleName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.externCompany.iut && _vm.isExternLikeStep
                    ? _c(
                        "div",
                        { staticClass: "col-4 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: _vm.isExternLikeStep,
                                  email: true
                                },
                                expression:
                                  "{ required: isExternLikeStep, email: true }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Correo del firmante (*)",
                              type: "email",
                              name: "responsibleEmail",
                              "data-vv-as": "correo del firmante",
                              "data-vv-validate-on": "blur",
                              "data-cy": "responsible-email",
                              danger: _vm.errors.has(
                                "flow-part-2.responsibleEmail"
                              ),
                              "danger-text": _vm.errors.first(
                                "flow-part-2.responsibleEmail"
                              )
                            },
                            model: {
                              value: _vm.step.extern.responsibleEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.step.extern,
                                  "responsibleEmail",
                                  $$v
                                )
                              },
                              expression: "step.extern.responsibleEmail"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.EXTERNAL
                    ? _c("div", { staticClass: "col-4 mt-3 text-primary" }, [
                        _c("ul", [
                          _c("li", [
                            _vm._v("- Este tipo de paso será "),
                            _c("b", [_vm._v("firmante")])
                          ]),
                          _c("li", [
                            _vm._v("- Este tipo de firma será "),
                            _c("b", [_vm._v("firma avanzada")])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.COMPLETION
                    ? _c("div", { staticClass: "col-4 mt-3 text-primary" }, [
                        _c("ul", [
                          _c("li", [
                            _vm._v("- Este tipo de paso será "),
                            _c("b", [_vm._v("revisor")])
                          ]),
                          _c("li", [
                            _vm._v("- El responsable "),
                            _c("b", [_vm._v("no firma")]),
                            _vm._v(", solo completa datos")
                          ]),
                          _c("li", [
                            _vm._v(
                              "- Completará los campos definidos sobre el PDF"
                            )
                          ]),
                          _c("li", [
                            _vm._v(
                              "- Los campos se definen en el paso siguiente"
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.stepType === _vm.stepTypes.PERSON
                    ? _c("div", { staticClass: "col-6 mt-3 text-primary" }, [
                        _c("ul", [
                          _c("li", [
                            _vm._v("- Este tipo de paso será "),
                            _c("b", [_vm._v("firmante")])
                          ]),
                          _c("li", [
                            _vm._v("- Este tipo de firma será "),
                            _c("b", [_vm._v("firma simple")])
                          ]),
                          _c("li", [
                            _vm._v(
                              "- Los datos ingresados no se pueden cambiar posteriormente"
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.stepType !== _vm.stepTypes.OFFICE &&
                  _vm.stepType !== _vm.stepTypes.EXTERNAL &&
                  _vm.stepType !== _vm.stepTypes.PERSON &&
                  _vm.stepType !== _vm.stepTypes.COMPLETION
                    ? _c(
                        "div",
                        { staticClass: "col-3 mt-3" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Tipo de rol (*)" } },
                            [
                              _c(
                                "vs-select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  class: {
                                    danger: _vm.errors.has(
                                      "flow-part-2.rolType"
                                    )
                                  },
                                  attrs: { autocomplete: "", name: "rolType" },
                                  model: {
                                    value: _vm.rolType,
                                    callback: function($$v) {
                                      _vm.rolType = $$v
                                    },
                                    expression: "rolType"
                                  }
                                },
                                _vm._l(_vm.rolTypesAvalaibles, function(rol) {
                                  return _c("vs-select-item", {
                                    key: rol.opcionId,
                                    attrs: {
                                      value: rol.valor,
                                      text: rol.descripcion
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("InfoRolType"),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "flow-part-2.rolType"
                                      ),
                                      expression:
                                        "errors.has('flow-part-2.rolType')"
                                    }
                                  ],
                                  staticClass:
                                    "danger span-text-validation-danger v-enter-to"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("flow-part-2.rolType")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            !_vm.step.oldFlow
              ? _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 d-flex align-items-end justify-content-end"
                    },
                    [
                      _c(
                        "vs-button",
                        {
                          attrs: {
                            "data-cy": "add-step",
                            color: "primary",
                            icon: "add",
                            disabled: _vm.blockButton
                          },
                          on: {
                            click: function($event) {
                              return _vm.addStep()
                            }
                          }
                        },
                        [_vm._v(" Agregar Paso ")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c("StepsFlow", {
              attrs: { steps: _vm.step.steps },
              on: { "remove-step": _vm.removeStep }
            }),
            _vm.useDistribution
              ? _c("DistributionFlow", {
                  attrs: { distributions: _vm.step.distributions },
                  on: {
                    "new-distribution": _vm.addDistribution,
                    "remove-distribution": _vm.removeDistribution
                  }
                })
              : _vm._e(),
            _vm.error.message !== ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                    staticStyle: { height: "32px" }
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.message) + " ")
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "b-modal",
          {
            ref: "usersExternCompany",
            attrs: {
              id: "users-extern-company",
              title: "Usuarios de la empresa " + _vm.externCompany.iut,
              "cancel-title": "Cancelar",
              size: "lg"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { height: "500px", overflow: "scroll" } },
              [
                _c("h5", [_vm._v("Estos usuarios ya existen en la empresa")]),
                _vm._l(_vm.externCompany.users, function(user) {
                  return _c(
                    "div",
                    {
                      key: user.id,
                      staticClass:
                        "employee-task mb-2 d-flex justify-content-between align-items-center step-box",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.selectUser(user)
                        }
                      }
                    },
                    [
                      _c(
                        "b-media",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-media-aside",
                            { staticClass: "mr-75" },
                            [
                              user.id
                                ? _c("b-avatar", {
                                    staticClass: "mt-25 mr-75",
                                    attrs: {
                                      rounded: "",
                                      text: _vm._f("avatarName")(user.nombre),
                                      size: "42"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("b-media-body", { staticClass: "my-auto" }, [
                            _c("h5", { staticClass: "mb-0" }, [
                              _vm._v(" " + _vm._s(user.nombre) + " ")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("small", { staticClass: "text-muted mr-75" }, [
                          _vm._v(" " + _vm._s(user.correo) + " ")
                        ])
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }